export default {
  Yes: 'Yes',
  No: 'No',
  Save: 'Save',
  Cancel: 'Discard',
  loginPage: {
    username: 'Username',
    password: 'Password',
    email: 'Email',
    logIn: 'Login',
    registry: 'Registry',
    hello: 'Hello {{name}}!',
    loginPrompt: 'Sign in to start using szukadło.',
    backToLogin: 'Back',
    error: {
      withoutRequiredData: 'Without required data.',
      worngLoginCredentials: 'Bad login credentials.',
      unexpected: 'Unexpected error',
      emailRequired: 'Email is required',
      invalidEmail: 'Invalid email format',
      passwordRequired: 'Password is required',
      passwordNeedsUppercase: 'Password must contain an uppercase letter',
      passwordNeedsNumber: 'Password must contain a number',
      invalidOtp: 'Invalid verification code',
      invalidUnblockCode: 'Invalid unblock code',
    },
    otp: {
      title: 'Two-factor authentication',
      sentToEmail: 'Verification code has been sent to your email.',
      useAuthApp: 'Enter the code from your authenticator app.',
      codeLabel: 'Verification code',
      verify: 'Verify',
      resend: 'Resend code',
      resendIn: 'Resend in {{seconds}}s',
    },
    blocked: {
      title: 'Account blocked',
      description: 'Your account has been blocked. Check your email and enter the unblock code.',
      codeLabel: 'Unblock code',
      unblock: 'Unblock account',
      success: 'Account has been unblocked. You can now log in.',
    },
    passkey: {
      or: 'or',
      signIn: 'Sign in with a passkey',
      error: {
        failed: 'Passkey sign-in failed',
        blocked: 'Your account has been blocked. Sign in with your password to unblock it.',
      },
    },
  },
  profilePage: {
    passkeys: {
      title: 'Passkeys',
      intro:
        'Passkeys let you sign in without a password — with your fingerprint, face, or device PIN. You can add a separate passkey on each device.',
      add: 'Add a passkey',
      empty: "You don't have any passkeys yet.",
      unnamed: 'Unnamed passkey',
      lastUsed: 'Last used: {{date}}',
      created: 'Created: {{date}}',
      rename: 'Rename',
      delete: 'Delete',
      nameDialog: {
        addTitle: 'Name your passkey',
        renameTitle: 'Rename passkey',
        label: 'Name',
        defaultName: 'New passkey',
        save: 'Save',
        cancel: 'Cancel',
      },
      deleteDialog: {
        title: 'Delete this passkey?',
        warning:
          'The "{{name}}" passkey will stop working on all your devices. This can only be undone by adding a new passkey.',
        confirm: 'Delete',
        cancel: 'Cancel',
      },
      snackbar: {
        added: 'Passkey added',
        renamed: 'Passkey renamed',
        deleted: 'Passkey deleted',
      },
      error: {
        loadFailed: 'Failed to load passkeys.',
        retry: 'Try again',
        generic: 'Something went wrong. Try again.',
        alreadyRegistered: 'This device already has a passkey for this account.',
      },
    },
  },
  registryPage: {
    hello: 'Nice to meet you {{name}}!',
    username: 'Username',
    password: 'Password',
    registry: 'Registry',
    email: 'Email',
    firstName: 'First name',
    repeatPassword: 'Password',
    error: {
      withoutRequiredData: 'Without required data',
      toShortPassword: 'To short password',
      badEmail: 'Bad email',
      unexpected: 'Unexpected error',
      passwordsShouldEquals: 'Passwords should be the same',
      duplicatedUsernameOrMail: 'Username with this email arleady exists',
    },
  },
  searchMenu: {
    // placeholder: 'What are you looking for?',
    searchFor: 'Search for “{{phrase}}”',
  },
  addBox: {
    filesCount_0: 'selected {{count}} file',
    filesCount_1: 'selected {{count}} files',
    filesCount_2: 'selected {{count}} files',
  },
  addPhotos: {
    sendingPhotosTitle: 'Uploading...',
    sendingPhotosDescription:
      'Trwa przesyłanie i automatyczne tagowaine zdjęć, ten proces może chwilę trwać, proszę nie opuszczaj tej strony dopóki proces nie dobiegnie końca',
    description: 'Wybierz i dodaj swoje zdjęcia!',
    showPreview: 'Zobacz zdjęcia',
    hidePreview: 'Ukryj zdjęcia',
    startImageSend: 'Rozpocznij przesyłanie',
    photosSendDoneTitle: 'Zdjęcia zostały wysłane!',
    photosSendDoneDesc: 'Twoje zdjęcia są już gotowe do wyszukania, na co czekasz?!',
    error: {
      error: 'An error has occured 😮',
      limit:
        'Zużyto limit przesłanych zdjęć, w celu odnowienia limitu skontaktuj się z administratorem',
    },
  },
  loading: {
    text: 'Loading...',
    video: 'Loading video...',
    searching: 'Searching...',
  },
  navBar: {
    selectTheme: 'Wybierz motyw',
    selectLanguage: 'Zmień język strony / Change website language',
    logout: 'Czy na pewno chcesz się wylogować?',
    profileTitle: 'Witaj {{name}}!',
    profileDesc: 'Tutaj możesz uzupełnić bądź zaktualizować swoje dane',
    avatarChange: 'Zmień avatar',
    adminPanel: 'Przejdź do panelu admina',
  },
  admin: {
    panel: 'Panel administratora',
    photos: 'Zdjęcia: {{count}}',
    user: 'Użytkownik',
    admin: 'Administrator',
  },
  photos: {
    hereYouWillSeeYourPhotos: 'Tutaj pojawią się twoje zdjęcia',
  },
  gallery: {
    today: 'Today',
    yesterday: 'Yesterday',
    groupByDate: 'Group by date',
  },
  galleryOptions: {
    title: 'Gallery options',
    layout: 'Layout',
    layoutJustified: 'River',
    layoutMasonry: 'Masonry',
    grouping: 'Grouping',
    byDate: 'By date',
    continuous: 'Continuous',
  },
  gallerySort: {
    title: 'Sorting',
    by: 'Sort by',
    order: 'Order',
    dateTaken: 'Date taken',
    dateUploaded: 'Date uploaded',
    dateAddedToAlbum: 'Date added',
    desc: 'Newest first',
    asc: 'Oldest first',
  },
  filters: {
    button: 'Filters',
    title: 'Filters',
    apply: 'Apply',
    clearAll: 'Clear filters',
    query: 'Query',
    queryPlaceholder: 'Enter a phrase...',
    album: 'Album',
    persons: 'People',
    personsPlaceholder: 'Add a person...',
    users: 'Sent by',
    usersPlaceholder: 'Add a user...',
    device: 'Device',
    devicePlaceholder: 'Select a device...',
    type: 'Type',
    typeImage: 'Photos',
    typeVideo: 'Videos',
    dateFrom: 'From',
    dateTo: 'To',
    noResults: 'No results',
    typeToSearch: 'Start typing to search',
  },
  dropZone: {
    dropHere: 'Drop files to upload',
    supportedFormats: 'Images and videos',
  },
  deleteAccount: {
    title: 'Delete account',
    description:
      "Enter your Szukadło account email. We'll send a confirmation link to it. Once confirmed, the account is blocked and then deleted.",
    emailLabel: 'Email',
    submit: 'Send confirmation link',
    sent: 'If an account with this address exists, we sent a confirmation link to it. The link is valid for 24 hours.',
    confirmTitle: 'Confirm account deletion',
    confirmDescription: 'Once confirmed, the account is blocked and then deleted.',
    confirm: 'Confirm account deletion',
    confirmed: 'The account has been blocked and will be deleted soon.',
    invalidLink: 'This link is invalid.',
    expired: 'The link has expired or was already used.',
    requestNewLink: 'Send a new link',
    error: {
      invalidEmail: 'Invalid email address format',
      tooManyRequests: 'Too many attempts. Please try again in a moment.',
      unexpected: 'An unexpected error occurred',
    },
  },
}
